document.addEventListener('DOMContentLoaded', function() {
	// Get the toggle button and menu elements
	const toggleButton = document.getElementById('toggle-nav');
	const mobileMenu = document.getElementById('off-canvas');
	const body = document.body;
	let menuOpen = false;

	// Check if elements exist
	if (!toggleButton || !mobileMenu) {
		console.error('Toggle button or mobile menu not found');
		return;
	}

	// Add click event to toggle button
	toggleButton.addEventListener('click', function(event) {
		event.preventDefault();

		// Get the icon span inside the toggle button
		const toggleIcon = toggleButton.querySelector('span.fa');

		if (!menuOpen) {
			// Open the menu
			mobileMenu.style.transition = 'left 0.3s ease-in-out';
			mobileMenu.style.left = '0px';
			mobileMenu.style.width = '100%';
			body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
			menuOpen = true;
			toggleButton.setAttribute('aria-expanded', 'true');
			mobileMenu.classList.remove('tp-hidden');

			// Change icon to close/X icon
			if (toggleIcon) {
				toggleIcon.classList.remove('fa-bars');
				toggleIcon.classList.add('fa-close');
			}
		} else {
			// Close the menu
			mobileMenu.style.left = '-300px';
			body.style.overflow = ''; // Restore scrolling
			mobileMenu.style.width = 'unset';
			menuOpen = false;
			toggleButton.setAttribute('aria-expanded', 'false');

			// Change icon back to bars/hamburger
			if (toggleIcon) {
				toggleIcon.classList.remove('fa-close');
				toggleIcon.classList.add('fa-bars');
			}

			// Add tp-hidden class after animation completes (on desktop only)
			setTimeout(function() {
				if (window.innerWidth >= 769) {
					mobileMenu.classList.add('tp-hidden');
				}
			}, 300); // Match this with the transition duration
		}
	});

	// Close menu if window is resized to desktop size
	window.addEventListener('resize', function() {
		if (window.innerWidth >= 769 && menuOpen) {
			mobileMenu.style.left = '-300px';
			mobileMenu.style.width = 'unset';
			body.style.overflow = '';
			menuOpen = false;
			toggleButton.setAttribute('aria-expanded', 'false');
			mobileMenu.classList.add('tp-hidden');

			// Reset icon to bars/hamburger
			const toggleIcon = toggleButton.querySelector('span.fa');
			if (toggleIcon) {
				toggleIcon.classList.remove('fa-close');
				toggleIcon.classList.add('fa-bars');
			}
		}
	});

	// Close menu when clicking outside
	document.addEventListener('click', function(event) {
		if (menuOpen && !mobileMenu.contains(event.target) && !toggleButton.contains(event.target)) {
			mobileMenu.style.left = '-300px';
			body.style.overflow = '';
			mobileMenu.style.width = 'unset';
			menuOpen = false;
			toggleButton.setAttribute('aria-expanded', 'false');

			// Reset icon to bars/hamburger when closing by clicking outside
			const toggleIcon = toggleButton.querySelector('span.fa');
			if (toggleIcon) {
				toggleIcon.classList.remove('fa-close');
				toggleIcon.classList.add('fa-bars');
			}

			setTimeout(function() {
				if (window.innerWidth >= 769) {
					mobileMenu.classList.add('tp-hidden');
				}
			}, 300);
		}
	});
});